import {AbstractControl, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';
import {DatePipe} from '@angular/common';

export function validateID(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

        if (!control) {
            console.error('Form controls cannot be found in the form group.')
            return {controlNotFound: false}
        }

        const idNumberRegex = /^(?<Year>[0-9][0-9])(?<Month>([0][1-9])|([1][0-2]))(?<Day>([0-2][0-9])|([3][0-1]))(?<Gender>[0-9])(?<Series>[0-9]{3})(?<Citizenship>[0-9])(?<Uniform>[0-9])(?<Control>[0-9])$/;
        if (!idNumberRegex.test(control.value)) {
            const error = {invalid_id: true};
            console.log('Invalid ID number: ', control.value + '-' + error);
            control.setErrors(error);
            return error;
        }
        console.log('Valid ID number: ', control.value);
        return null;
    };
}

